import React, {useCallback, useEffect, useState} from "react";
import {LogoEditorView} from "./logo-editor.view";
import PropTypes, {InferProps} from "prop-types";
import {usePrompt} from "../../../../front/services/src/lib/lab.service";
import {PromptResult, PromptStyle, PromptType} from "@betrue/shared/interfaces";
import {usePerson, usePrincipal} from "@betrue/front/services";
import {v4 as uuid} from 'uuid';

export const LogoEditorPropsTypes = {
  promptLabel: PropTypes.string,
  styleLabel: PropTypes.string,

}
export type LogoEditorProps = InferProps<typeof LogoEditorPropsTypes>
export const LogoEditor = (props: LogoEditorProps) => {

  const [current] = usePrincipal()

  const [userId, setUserId] = useState(null)
  const [model, setModel] = useState("v1-5-pruned-emaonly.safetensors")
  const [error, setError] = useState(false)
  const [logos, setLogos] = useState<PromptResult[]>([])
  const [imageRef, setImageRef] = useState(null)
  const [inputWeight, setInputWeight] = useState(1)

  const [logo, promptStyles, promptsHistory, {findUserPrompts, createLogo, getPromptStyles}] = usePrompt()

  const [promptTemplateId, setSelectedPromptTemplateId] = useState<string>("")

  const [chronos, setChronos] = useState(0.0)

  const [pending, setPending] = useState(false)


  useEffect(() => {
    if (promptsHistory) {
      setLogos([...promptsHistory])
    }

  }, [promptsHistory])

  useEffect(() => {
    if (!promptStyles) {
      getPromptStyles()
    }

    let userId = null
    console.log('current', current)
    if (current) {
      userId = current.id
    } else {
      const storedUser = localStorage.getItem('userId')
      if (storedUser) {
        userId = storedUser
      } else {
        userId = uuid()
        localStorage.setItem('userId', userId)
      }
    }
    setUserId(userId)

  }, [current])


  useEffect(() => {
    if (userId) {
      findUserPrompts(userId)
    }

  }, [userId])

  useEffect(() => {
    if (pending) {
      setTimeout(() => {
        setChronos((Math.round((chronos + 0.10) * 100) / 100))
      }, 100)
    } else {
      setChronos(0)
    }

  }, [chronos, pending])

  useEffect(() => {
    if (pending) {
      setChronos(0.1)
    } else {
      setChronos(0)
    }

  }, [pending])

  useEffect(() => {
    if (logo instanceof Error) {
      setPending(false)
      setError(true)
    } else if (logo) {
      setPending(false)
      setLogos([...logos, logo])
    }

  }, [logo])


  const handleErrorClose = useCallback(() => {
    setError(false)
  }, [])

  const handleGenerate = useCallback((prompt: string) => {

    setPending(true)
    if (promptTemplateId && prompt) {


      createLogo({
        userId: userId,
        inputImage: imageRef,
        promptTemplateId: promptTemplateId,
        prompt: prompt,
        weight: inputWeight,
        type: PromptType.TXT2IMG
      })
    }
  }, [promptTemplateId, userId, model, imageRef, inputWeight])

  const handleModelChanged = useCallback((model: string) => {
    setModel(model)
  }, [])

  const handleSelectedPromptTemplateId = useCallback((id: string) => {
    setSelectedPromptTemplateId(id)
    if(promptStyles){
      const weight = promptStyles.filter((s) => s.id === id )[0]?.weight
      if(weight) {
        setInputWeight(weight)

      }
    }


  }, [promptStyles])

  return (
    <LogoEditorView  {...props} handleSelectedPromptTemplateId={handleSelectedPromptTemplateId}
                     selectedPromptTemplateId={promptTemplateId}
                     model={model}
                     errorOpen={error}
                     imageRef={imageRef}
                     setInputWeight={setInputWeight}
                     inputWeight={inputWeight}
                     setImageRef={setImageRef}
                     handleErrorClose={handleErrorClose}
                     principal={current}
                     handleModelChanged={handleModelChanged}
                     handleGenerate={handleGenerate} generatedLogos={logos}
                     chronos={chronos} promptStyles={promptStyles}/>
  );
}
LogoEditor.propTypes = LogoEditorPropsTypes
